export function isWechat() {
  const ua = navigator.userAgent.toLowerCase();
  return /micromessenger/i.test(ua) || /wechat/i.test(ua);
}

export function isLvmio() {
  return !!window.flutter_inappwebview;
}
export const lvmio = window.flutter_inappwebview;
